import { CU_SERVICIO_CONDICION, CU_SERVICIO_PERIODO } from "@/apollo/mutations/benefit";
import { FIND_PERIODOS_CONDICIONES_EMPRESA, LIST_TIPO_CONDICIONES, LIST_TIPO_PERIODOS } from "@/apollo/queries/benefit";
import {
  exQue,
  exMut
} from "@/utils/gql";

export const [stateSettings, mutationsSettings, actionsSettings] = [{
  //State Settings
  ListTipoPeriodos: null,
  ListTipoCondiciones: null,
  FindPeriodosCondicionesEmpresa: null,
  loadingSettings: false,
}, {
  //Mutations Settings
  SetListTipoPeriodos(state, data) {
    state.ListTipoPeriodos = data;
  },
  SetListTipoCondiciones(state, data) {
    state.ListTipoCondiciones = data;
  },
  SetFindPeriodosCondicionesEmpresa(state, data) {
    state.FindPeriodosCondicionesEmpresa = data;
  },
}, {
  //Actions Settings
  getSettings({ dispatch }) {
    return Promise.all([
      dispatch("getListTipoPeriodos"),
      dispatch("getListTipoCondiciones"),
      dispatch("getFindPeriodosCondicionesEmpresa"),
    ]);
  },
  getListTipoPeriodos({ commit }) {
    return exQue(LIST_TIPO_PERIODOS).then((data) => {
      commit("SetListTipoPeriodos", data);
      /*
      ListaTipoPeriodos:[{"id_tipo":1,"nombre":"Siempre","is_dia":false,"is_rango":"false","is_transversal":"true","__typename":"TipoPeriodos"},{"id_tipo":2,"nombre":"Días","is_dia":true,"is_rango":"false","is_transversal":"false","__typename":"TipoPeriodos"},{"id_tipo":3,"nombre":"Rango de fechas","is_dia":false,"is_rango":"true","is_transversal":"false","__typename":"TipoPeriodos"}]
      */
    }).catch((error) => {
      console.error("Error fetching ListTipoPeriodos:", error);
    }
    );
  },
  getListTipoCondiciones({ commit }) {
    return exQue(LIST_TIPO_CONDICIONES).then((data) => {
      commit("SetListTipoCondiciones", data);
      /*
      ListaTipoCondiciones:[{"id_tipo":1,"nombre":"Sin restricción","campo_bd":null,"is_transversal":true,"__typename":"TipoCondiciones"},{"id_tipo":2,"nombre":"Áreas / Gerencia","campo_bd":"id_gerencia_fk","is_transversal":false,"__typename":"TipoCondiciones"},{"id_tipo":3,"nombre":"Fecha Ingreso","campo_bd":"fecha_ingreso","is_transversal":false,"__typename":"TipoCondiciones"},{"id_tipo":4,"nombre":"Género","campo_bd":"genero","is_transversal":false,"__typename":"TipoCondiciones"},{"id_tipo":5,"nombre":"Fecha Nacimiento","campo_bd":"fecha_nacimiento","is_transversal":false,"__typename":"TipoCondiciones"}]
      */
    }).catch((error) => {
      console.error("Error fetching ListTipoCondiciones:", error);
    }
    );
  },
  getFindPeriodosCondicionesEmpresa({ commit }) {
    return exQue(FIND_PERIODOS_CONDICIONES_EMPRESA).then((data) => {
      commit("SetFindPeriodosCondicionesEmpresa", data);
      /*
      FindPeriodosCondicionesEmpresa:[{"id_solicitud_empresa":"1","nombre":"","descripcion":"Solicitudes de Gas","id_tipo_solicitud_fk":"1","solicitud_tipo":{"id_tipo":"1","nombre_solicitud":"Gas","descripcion":"Solicitudes de Gas","url_imagen":"https://storage.googleapis.com/c3-bucket-01/iconos_solicitudes/gas.png","__typename":"TipoSolicitudesSimple"},"periodos":[{"id_periodo":"15","nombre":"Periodo por días","descripcion":"Periodo por días","tipo_tiempo":"0","tiempo_inicio":null,"tiempo_final":null,"tiempo_dia":3,"tipo":{"id_tipo":2,"nombre":"Días","is_dia":true,"is_rango":"false","is_transversal":"false","__typename":"TipoPeriodos"},"__typename":"PeriodoEmpresa"},{"id_periodo":"14","nombre":"Periodo por días","descripcion":"Periodo por días","tipo_tiempo":"0","tiempo_inicio":null,"tiempo_final":null,"tiempo_dia":2,"tipo":{"id_tipo":2,"nombre":"Días","is_dia":true,"is_rango":"false","is_transversal":"false","__typename":"TipoPeriodos"},"__typename":"PeriodoEmpresa"},{"id_periodo":"13","nombre":"Periodo por días","descripcion":"Periodo por días","tipo_tiempo":"0","tiempo_inicio":null,"tiempo_final":null,"tiempo_dia":1,"tipo":{"id_tipo":2,"nombre":"Días","is_dia":true,"is_rango":"false","is_transversal":"false","__typename":"TipoPeriodos"},"__typename":"PeriodoEmpresa"}],"condiciones":[{"id_condicion":"11","c_area":null,"c_ingreso_desde":"3","c_ingreso_hasta":null,"c_genero":null,"c_nacimiento_desde":null,"c_nacimiento_hasta":null,"id_solicitud_empresa_fk":"1","id_tipo_fk":"3","id_empresa_fk":"1","tipo":{"id_tipo":3,"nombre":"Fecha Ingreso","campo_bd":"fecha_ingreso","is_transversal":false,"__typename":"TipoCondiciones"},"__typename":"CondicionesEmpresa"}],"__typename":"SolicitudesEmpresaCondicionesPeriodo"},{"id_solicitud_empresa":"2","nombre":"","descripcion":"Solicitudes de Producto","id_tipo_solicitud_fk":"2","solicitud_tipo":{"id_tipo":"2","nombre_solicitud":"Caja de Salmón","descripcion":"Solicitudes de Producto","url_imagen":"https://storage.googleapis.com/c3-bucket-01/iconos_solicitudes/productos.png","__typename":"TipoSolicitudesSimple"},"periodos":[{"id_periodo":"1","nombre":"","descripcion":"","tipo_tiempo":"1","tiempo_inicio":"2022-01-01T00:00:00.000Z","tiempo_final":"2026-12-31T00:00:00.000Z","tiempo_dia":null,"tipo":{"id_tipo":3,"nombre":"Rango de fechas","is_dia":false,"is_rango":"true","is_transversal":"false","__typename":"TipoPeriodos"},"__typename":"PeriodoEmpresa"}],"condiciones":[],"__typename":"SolicitudesEmpresaCondicionesPeriodo"},{"id_solicitud_empresa":"3","nombre":"","descripcion":"Solicitud de Fondo Educacional","id_tipo_solicitud_fk":"3","solicitud_tipo":{"id_tipo":"3","nombre_solicitud":"Fondo Educacional","descripcion":"Solicita el beneficio de fondo educacional","url_imagen":"https://storage.googleapis.com/c3-bucket-01/iconos_solicitudes/beneficios-solicitudes.png","__typename":"TipoSolicitudesSimple"},"periodos":[],"condiciones":[],"__typename":"SolicitudesEmpresaCondicionesPeriodo"},{"id_solicitud_empresa":"8","nombre":" ","descripcion":"Suscripción de abonados para Deporte Copiapó","id_tipo_solicitud_fk":"5","solicitud_tipo":{"id_tipo":"5","nombre_solicitud":"Suscripción de abonados para Deporte Copiapó","descripcion":"Suscripción de abonados para Deporte Copiapó","url_imagen":"https://storage.googleapis.com/c3-bucket-01/iconos_solicitudes/productos.png","__typename":"TipoSolicitudesSimple"},"periodos":[],"condiciones":[],"__typename":"SolicitudesEmpresaCondicionesPeriodo"}]
      */
    }).catch((error) => {
      console.error("Error fetching FindPeriodosCondicionesEmpresa:", error);
    }
    );
  },

  /**
   * Crea o actualiza el periodo de disponibilidad de un servicio.
   * @param {number} idSolicitud - ID del servicio/solicitud empresa.
   * @param {number} idTipo - ID del tipo de periodo (1=Siempre, 2=Días, 3=Rango de fechas).
   * @param {Array<{inicio: string, fin: string}>} rangos - Rangos de fechas (usado cuando idTipo=3).
   * @param {number[]} diasSemana - Días de la semana 1-7 (usado cuando idTipo=2).
   */
  CUServicioPeriodo(_, {
    idSolicitud = null, idTipo = null, rangos = [], diasSemana = []
  }) {
    return new Promise((resolve, reject) => {
      exMut(CU_SERVICIO_PERIODO, {
        idSolicitud,
        idTipo,
        rangos,
        diasSemana
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error("Error executing CU_SERVICIO_PERIODO:", error);
        reject(error);
      });
    });
  },
  /**
   * Crea o actualiza la condición de restricción de un servicio.
   * @param {number} idSolicitud - ID del servicio/solicitud empresa.
   * @param {number} idTipo - ID del tipo de condición (1=Sin restricción, 2=Área, 3=Fecha Ingreso, 4=Género, 5=Fecha Nacimiento).
   * @param {number[]} cArea - IDs de gerencias/áreas restringidas.
   * @param {string[]} cGenero - Géneros permitidos.
   * @param {Array<{desde: number, hasta: number}>} cIngreso - Rango de meses de antigüedad en la compañía.
   * @param {Array<{desde: number, hasta: number}>} cNacimiento - Rango de años de nacimiento.
   */
  CUServicioCondicion(_, {
    idSolicitud = null, idTipo = null, cArea = [], cGenero = [], cIngreso = [], cNacimiento = []
  }) {
    return new Promise((resolve, reject) => {
      exMut(CU_SERVICIO_CONDICION, {
        idSolicitud,
        idTipo,
        cArea,
        cGenero,
        cIngreso,
        cNacimiento
      }).then((data) => {
        resolve(data);
      }).catch((error) => {
        console.error("Error executing CU_SERVICIO_CONDICION:", error);
        reject(error);
      });
    });
  },
}];